import React, {useState, useEffect, useContext, Suspense, lazy} from "react";
import {useTranslation} from "react-i18next";
import "./Project.scss";
import Button from "../../components/button/Button";
import {openSource, socialMediaLinks} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import Loading from "../../containers/loading/Loading";
export default function Projects() {
  const {t} = useTranslation();
  const GithubRepoCard = lazy(() =>
    import("../../components/githubRepoCard/GithubRepoCard")
  );
  const FailedLoading = () => null;
  const renderLoader = () => <Loading />;
  const [repo, setrepo] = useState([]);
  // todo: remove useContex because is not supported
  const {isDark} = useContext(StyleContext);

  useEffect(() => {
    const getRepoData = () => {
      // Try multiple paths to ensure it works with different homepage configurations
      const tryFetch = async () => {
        const paths = [
          "/profile.json",
          `${process.env.PUBLIC_URL}/profile.json`,
          "./profile.json"
        ];
        
        for (const path of paths) {
          try {
            const result = await fetch(path);
            if (result.ok) {
              const response = await result.json();
              setrepoFunction(response.data.user.pinnedItems.edges);
              return;
            }
          } catch (error) {
            console.warn(`Failed to fetch from ${path}:`, error);
          }
        }
        
        // If all paths fail, throw an error
        throw new Error("Could not fetch profile data from any path");
      };
      
      tryFetch().catch(function (error) {
        console.error(
          `${error} (because of this error, nothing is shown in place of Projects section. Also check if Projects section has been configured)`
        );
        setrepoFunction("Error");
      });
    };
    getRepoData();
  }, []);

  function setrepoFunction(array) {
    setrepo(array);
  }
  if (
    !(typeof repo === "string" || repo instanceof String) &&
    openSource.display
  ) {
    return (
      <Suspense fallback={renderLoader()}>
        <div className="main" id="opensource">
          <h1 className="project-title">{t("opensource.title")}</h1>
          <div className="repo-cards-div-main">
            {repo.map((v, i) => {
              if (!v) {
                console.error(
                  `Github Object for repository number : ${i} is undefined`
                );
              }
              return (
                <GithubRepoCard repo={v} key={v.node.id} isDark={isDark} />
              );
            })}
          </div>
          <Button
            text={"More Projects"}
            className="project-button"
            href={socialMediaLinks.github}
            newTab={true}
          />
        </div>
      </Suspense>
    );
  } else {
    return <FailedLoading />;
  }
}
